export var CHAINS_ENUM;
(function (CHAINS_ENUM) {
    CHAINS_ENUM["ETH"] = "ETH";
    CHAINS_ENUM["BSC"] = "BSC";
    CHAINS_ENUM["GNOSIS"] = "GNOSIS";
    CHAINS_ENUM["HECO"] = "HECO";
    CHAINS_ENUM["POLYGON"] = "POLYGON";
    CHAINS_ENUM["FTM"] = "FTM";
    CHAINS_ENUM["OKT"] = "OKT";
    CHAINS_ENUM["ARBITRUM"] = "ARBITRUM";
    CHAINS_ENUM["AVAX"] = "AVAX";
    CHAINS_ENUM["OP"] = "OP";
    CHAINS_ENUM["CELO"] = "CELO";
    CHAINS_ENUM["MOVR"] = "MOVR";
    CHAINS_ENUM["CRO"] = "CRO";
    CHAINS_ENUM["BOBA"] = "BOBA";
    CHAINS_ENUM["METIS"] = "METIS";
    CHAINS_ENUM["BTT"] = "BTT";
    CHAINS_ENUM["AURORA"] = "AURORA";
    CHAINS_ENUM["MOBM"] = "MOBM";
    CHAINS_ENUM["SBCH"] = "SBCH";
    CHAINS_ENUM["FUSE"] = "FUSE";
    CHAINS_ENUM["HMY"] = "HMY";
    CHAINS_ENUM["ASTAR"] = "ASTAR";
    CHAINS_ENUM["KLAY"] = "KLAY";
    CHAINS_ENUM["IOTX"] = "IOTX";
    CHAINS_ENUM["RSK"] = "RSK";
    CHAINS_ENUM["WAN"] = "WAN";
    CHAINS_ENUM["KCC"] = "KCC";
    CHAINS_ENUM["SGB"] = "SGB";
    CHAINS_ENUM["EVMOS"] = "EVMOS";
    CHAINS_ENUM["DFK"] = "DFK";
    CHAINS_ENUM["TLOS"] = "TLOS";
    CHAINS_ENUM["NOVA"] = "NOVA";
    CHAINS_ENUM["CANTO"] = "CANTO";
    CHAINS_ENUM["DOGE"] = "DOGE";
    CHAINS_ENUM["STEP"] = "STEP";
    CHAINS_ENUM["KAVA"] = "KAVA";
    CHAINS_ENUM["MADA"] = "MADA";
    CHAINS_ENUM["CFX"] = "CFX";
    CHAINS_ENUM["BRISE"] = "BRISE";
    CHAINS_ENUM["CKB"] = "CKB";
    CHAINS_ENUM["TOMB"] = "TOMB";
    CHAINS_ENUM["PZE"] = "PZE";
    CHAINS_ENUM["ERA"] = "ERA";
    CHAINS_ENUM["EOS"] = "EOS";
    CHAINS_ENUM["CORE"] = "CORE";
    CHAINS_ENUM["FLR"] = "FLR";
    CHAINS_ENUM["WEMIX"] = "WEMIX";
    CHAINS_ENUM["METER"] = "METER";
    CHAINS_ENUM["ETC"] = "ETC";
    CHAINS_ENUM["FSN"] = "FSN";
    CHAINS_ENUM["PULSE"] = "PULSE";
    CHAINS_ENUM["ROSE"] = "ROSE";
    CHAINS_ENUM["RONIN"] = "RONIN";
    CHAINS_ENUM["OAS"] = "OAS";
    CHAINS_ENUM["ZORA"] = "ZORA";
    CHAINS_ENUM["LINEA"] = "LINEA";
    CHAINS_ENUM["BASE"] = "BASE";
    CHAINS_ENUM["GETH"] = "GETH";
    CHAINS_ENUM["GARBITRUM"] = "GARBITRUM";
    CHAINS_ENUM["CGNOSIS"] = "CGNOSIS";
    CHAINS_ENUM["MANTLE"] = "MANTLE";
    CHAINS_ENUM["TENET"] = "TENET";
    CHAINS_ENUM["TBSC"] = "TBSC";
    CHAINS_ENUM["MPOLYGON"] = "MPOLYGON";
    CHAINS_ENUM["GOP"] = "GOP";
    CHAINS_ENUM["GBOBA"] = "GBOBA";
    CHAINS_ENUM["GBASE"] = "GBASE";
    CHAINS_ENUM["GLINEA"] = "GLINEA";
    CHAINS_ENUM["TFTM"] = "TFTM";
    CHAINS_ENUM["LYX"] = "LYX";
    CHAINS_ENUM["TLYX"] = "TLYX";
    CHAINS_ENUM["TDEBANK"] = "TDEBANK";
    CHAINS_ENUM["TMNT"] = "TMNT";
    CHAINS_ENUM["OPBNB"] = "OPBNB";
    CHAINS_ENUM["GERA"] = "GERA";
    CHAINS_ENUM["PMANTA"] = "PMANTA";
    CHAINS_ENUM["TOPBNB"] = "TOPBNB";
    CHAINS_ENUM["TTENET"] = "TTENET";
    CHAINS_ENUM["LOOT"] = "LOOT";
    CHAINS_ENUM["TLOOT"] = "TLOOT";
    CHAINS_ENUM["SETH"] = "SETH";
    CHAINS_ENUM["SSCROLL"] = "SSCROLL";
    CHAINS_ENUM["AZETA"] = "AZETA";
    CHAINS_ENUM["TALT"] = "TALT";
    CHAINS_ENUM["GZORA"] = "GZORA";
    CHAINS_ENUM["SHIB"] = "SHIB";
    CHAINS_ENUM["TAVAX"] = "TAVAX";
    CHAINS_ENUM["PSHIB"] = "PSHIB";
    CHAINS_ENUM["GMETIS"] = "GMETIS";
    CHAINS_ENUM["SARB"] = "SARB";
    CHAINS_ENUM["TSTLS"] = "TSTLS";
    CHAINS_ENUM["CFLR"] = "CFLR";
    CHAINS_ENUM["ACELO"] = "ACELO";
    CHAINS_ENUM["DBTT"] = "DBTT";
    CHAINS_ENUM["TEVMOS"] = "TEVMOS";
    CHAINS_ENUM["MANTA"] = "MANTA";
    CHAINS_ENUM["TDFK"] = "TDFK";
    CHAINS_ENUM["TWEMIX"] = "TWEMIX";
    CHAINS_ENUM["TSTEP"] = "TSTEP";
    CHAINS_ENUM["METC"] = "METC";
    CHAINS_ENUM["TFSN"] = "TFSN";
    CHAINS_ENUM["AMOBM"] = "AMOBM";
    CHAINS_ENUM["TKCC"] = "TKCC";
    CHAINS_ENUM["TIOTX"] = "TIOTX";
    CHAINS_ENUM["TPLS"] = "TPLS";
    CHAINS_ENUM["HETH"] = "HETH";
    CHAINS_ENUM["BKLAY"] = "BKLAY";
    CHAINS_ENUM["CSGB"] = "CSGB";
    CHAINS_ENUM["TKAVA"] = "TKAVA";
    CHAINS_ENUM["SCRL"] = "SCRL";
    CHAINS_ENUM["FX"] = "FX";
    CHAINS_ENUM["DFX"] = "DFX";
    CHAINS_ENUM["TAURORA"] = "TAURORA";
    CHAINS_ENUM["TCRO"] = "TCRO";
    CHAINS_ENUM["SMODE"] = "SMODE";
    CHAINS_ENUM["TIMXZE"] = "TIMXZE";
    CHAINS_ENUM["KTAIKO"] = "KTAIKO";
    CHAINS_ENUM["SSYNP"] = "SSYNP";
    CHAINS_ENUM["TCFX"] = "TCFX";
    CHAINS_ENUM["TX1"] = "TX1";
    CHAINS_ENUM["TSBY"] = "TSBY";
    CHAINS_ENUM["TAZE"] = "TAZE";
    CHAINS_ENUM["BEAM"] = "BEAM";
    CHAINS_ENUM["TBEAM"] = "TBEAM";
    CHAINS_ENUM["TFRAX"] = "TFRAX";
    CHAINS_ENUM["TPEGO"] = "TPEGO";
    CHAINS_ENUM["TFRAME"] = "TFRAME";
    CHAINS_ENUM["PEGO"] = "PEGO";
    CHAINS_ENUM["ZKFAIR"] = "ZKFAIR";
    CHAINS_ENUM["TRSK"] = "TRSK";
    CHAINS_ENUM["TALOT"] = "TALOT";
    CHAINS_ENUM["FON"] = "FON";
    CHAINS_ENUM["BFC"] = "BFC";
    CHAINS_ENUM["TBFC"] = "TBFC";
    CHAINS_ENUM["ABERA"] = "ABERA";
    CHAINS_ENUM["ALOT"] = "ALOT";
    CHAINS_ENUM["XAI"] = "XAI";
    CHAINS_ENUM["TSAVM"] = "TSAVM";
    CHAINS_ENUM["GXAI"] = "GXAI";
    CHAINS_ENUM["SXAI"] = "SXAI";
    CHAINS_ENUM["SBLAST"] = "SBLAST";
    CHAINS_ENUM["ZETA"] = "ZETA";
    CHAINS_ENUM["RARI"] = "RARI";
    CHAINS_ENUM["HUBBLE"] = "HUBBLE";
    CHAINS_ENUM["TRARI"] = "TRARI";
    CHAINS_ENUM["MODE"] = "MODE";
    CHAINS_ENUM["MERLIN"] = "MERLIN";
    CHAINS_ENUM["DYM"] = "DYM";
})(CHAINS_ENUM || (CHAINS_ENUM = {}));
export const CHAINS_RAW = {
    [CHAINS_ENUM.ETH]: {
        id: 1,
        serverId: "eth",
        name: "Ethereum",
        hex: "0x1",
        enum: CHAINS_ENUM.ETH,
        network: "1",
        nativeTokenSymbol: "ETH",
        nativeTokenLogo: "https://static.debank.com/image/token/logo_url/eth/935ae4e4d1d12d59a99717a24f2540b5.png",
        nativeTokenDecimals: 18,
        nativeTokenAddress: "eth",
        scanLink: "https://etherscan.io/tx/_s_",
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.BSC]: {
        id: 56,
        name: "BNB Chain",
        serverId: "bsc",
        hex: "0x38",
        enum: CHAINS_ENUM.BSC,
        network: "56",
        nativeTokenSymbol: "BNB",
        nativeTokenAddress: "bsc",
        scanLink: "https://bscscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/bsc_token/logo_url/bsc/8bfdeaa46fe9be8f5cd43a53b8d1eea1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.GNOSIS]: {
        id: 100,
        name: "Gnosis Chain",
        serverId: "xdai",
        hex: "0x64",
        enum: CHAINS_ENUM.GNOSIS,
        network: "100",
        nativeTokenSymbol: "xDai",
        nativeTokenAddress: "xdai",
        scanLink: "https://gnosisscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/xdai_token/logo_url/xdai/1207e67652b691ef3bfe04f89f4b5362.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.POLYGON]: {
        id: 137,
        serverId: "matic",
        name: "Polygon",
        hex: "0x89",
        enum: CHAINS_ENUM.POLYGON,
        network: "137",
        nativeTokenSymbol: "MATIC",
        nativeTokenAddress: "matic",
        nativeTokenDecimals: 18,
        scanLink: "https://polygonscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/matic_token/logo_url/matic/e5a8a2860ba5cf740a474dcab796dc63.png",
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.FTM]: {
        id: 250,
        serverId: "ftm",
        name: "Fantom",
        hex: "0xfa",
        enum: CHAINS_ENUM.FTM,
        network: "250",
        nativeTokenSymbol: "FTM",
        nativeTokenAddress: "ftm",
        scanLink: "https://ftmscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/token/logo_url/eth/935ae4e4d1d12d59a99717a24f2540b5.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.OKT]: {
        id: 66,
        serverId: "okt",
        name: "OKC",
        enum: CHAINS_ENUM.OKT,
        hex: "0x42",
        network: "66",
        nativeTokenSymbol: "OKT",
        nativeTokenAddress: "okt",
        scanLink: "https://www.oklink.com/okexchain/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/ftm_token/logo_url/ftm/33fdb9c5067e94f3a1b9e78f6fa86984.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.HECO]: {
        id: 128,
        serverId: "heco",
        name: "HECO",
        enum: CHAINS_ENUM.HECO,
        hex: "0x80",
        network: "128",
        nativeTokenSymbol: "HT",
        nativeTokenAddress: "heco",
        scanLink: "https://hecoscan.io/#/transaction/_s_",
        nativeTokenLogo: "https://static.debank.com/image/heco_token/logo_url/heco/c399dcddde07e1944c4dd8f922832b53.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.AVAX]: {
        id: 43114,
        serverId: "avax",
        network: "43114",
        name: "Avalanche",
        nativeTokenSymbol: "AVAX",
        nativeTokenAddress: "avax",
        enum: CHAINS_ENUM.AVAX,
        hex: "0xa86a",
        scanLink: "https://snowtrace.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/avax_token/logo_url/avax/0b9c84359c84d6bdd5bfda9c2d4c4a82.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.ARBITRUM]: {
        id: 42161,
        serverId: "arb",
        name: "Arbitrum",
        enum: CHAINS_ENUM.ARBITRUM,
        hex: "0xa4b1",
        network: "42161",
        nativeTokenSymbol: "ETH",
        nativeTokenAddress: "arb",
        scanLink: "https://arbiscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/arb_token/logo_url/arb/d61441782d4a08a7479d54aea211679e.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.OP]: {
        id: 10,
        serverId: "op",
        network: "10",
        name: "Optimism",
        enum: CHAINS_ENUM.OP,
        hex: "0xa",
        scanLink: "https://optimistic.etherscan.io/tx/_s_",
        nativeTokenSymbol: "ETH",
        nativeTokenAddress: "op",
        nativeTokenLogo: "https://static.debank.com/image/op_token/logo_url/op/d61441782d4a08a7479d54aea211679e.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.CELO]: {
        id: 42220,
        serverId: "celo",
        network: "42220",
        name: "Celo",
        nativeTokenSymbol: "CELO",
        nativeTokenAddress: "celo",
        enum: CHAINS_ENUM.CELO,
        hex: "0xa4ec",
        scanLink: "https://celoscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/celo_token/logo_url/0x471ece3750da237f93b8e339c536989b8978a438/6f524d91db674876ba0f5767cf0124cc.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.MOVR]: {
        id: 1285,
        serverId: "movr",
        network: "1285",
        name: "Moonriver",
        nativeTokenSymbol: "MOVR",
        nativeTokenAddress: "movr",
        enum: CHAINS_ENUM.MOVR,
        hex: "0x505",
        scanLink: "https://moonriver.moonscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/movr/c66f89fdceaea8d8fce263a1f816d671.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.CRO]: {
        id: 25,
        serverId: "cro",
        network: "25",
        name: "Cronos",
        nativeTokenSymbol: "CRO",
        nativeTokenAddress: "cro",
        enum: CHAINS_ENUM.CRO,
        hex: "0x19",
        scanLink: "https://cronoscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/cro/affddd53019ffb9dbad0c724e12500c0.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.BOBA]: {
        id: 288,
        serverId: "boba",
        network: "288",
        name: "Boba",
        nativeTokenSymbol: "ETH",
        nativeTokenAddress: "boba",
        enum: CHAINS_ENUM.BOBA,
        hex: "0x120",
        scanLink: "https://blockexplorer.boba.network/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/op_token/logo_url/0x4200000000000000000000000000000000000006/d61441782d4a08a7479d54aea211679e.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.METIS]: {
        id: 1088,
        serverId: "metis",
        network: "1088",
        name: "Metis",
        nativeTokenSymbol: "Metis",
        nativeTokenAddress: "metis",
        enum: CHAINS_ENUM.METIS,
        hex: "0x440",
        scanLink: "https://explorer.metis.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/metis/b289da32db4d860ebf6fb46a6e41dcfc.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.BTT]: {
        id: 199,
        serverId: "btt",
        network: "199",
        name: "BTTC",
        nativeTokenSymbol: "BTT",
        nativeTokenAddress: "btt",
        enum: CHAINS_ENUM.BTT,
        hex: "0xc7",
        scanLink: "https://bttcscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/btt/2130a8d57ff2a0f3d50a4ec9432897c6.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.AURORA]: {
        id: 1313161554,
        serverId: "aurora",
        network: "1313161554",
        name: "Aurora",
        nativeTokenSymbol: "AETH",
        nativeTokenAddress: "aurora",
        enum: CHAINS_ENUM.AURORA,
        hex: "0x4e454152",
        scanLink: "https://aurorascan.dev/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/token/logo_url/eth/935ae4e4d1d12d59a99717a24f2540b5.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.MOBM]: {
        id: 1284,
        serverId: "mobm",
        network: "1284",
        name: "Moonbeam",
        nativeTokenSymbol: "GLMR",
        nativeTokenAddress: "mobm",
        enum: CHAINS_ENUM.MOBM,
        hex: "0x504",
        scanLink: "https://moonscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/mobm_token/logo_url/mobm/a8442077d76b258297181c3e6eb8c9cc.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.SBCH]: {
        id: 10000,
        serverId: "sbch",
        network: "10000",
        name: "smartBCH",
        nativeTokenSymbol: "BCH",
        nativeTokenAddress: "sbch",
        enum: CHAINS_ENUM.SBCH,
        hex: "0x2710",
        scanLink: "https://www.smartscan.cash/transaction/_s_",
        nativeTokenLogo: "https://static.debank.com/image/sbch_token/logo_url/sbch/03007b5353bb9e221efb82a6a70d9ec9.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.HMY]: {
        id: 1666600000,
        serverId: "hmy",
        network: "1666600000",
        name: "Harmony",
        nativeTokenSymbol: "ONE",
        nativeTokenAddress: "hmy",
        enum: CHAINS_ENUM.HMY,
        hex: "0x63564c40",
        scanLink: "https://explorer.harmony.one/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/hmy/734c003023531e31c636ae25d5a73172.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.FUSE]: {
        id: 122,
        serverId: "fuse",
        network: "122",
        name: "Fuse",
        nativeTokenSymbol: "FUSE",
        nativeTokenAddress: "fuse",
        enum: CHAINS_ENUM.FUSE,
        hex: "0x7a",
        scanLink: "https://explorer.fuse.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/fuse/ea4c9e12e7f646d42aa8fb07ab8dfec8.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.ASTAR]: {
        id: 592,
        serverId: "astar",
        network: "592",
        name: "Astar",
        nativeTokenSymbol: "ASTR",
        nativeTokenAddress: "astar",
        enum: CHAINS_ENUM.ASTAR,
        hex: "0x250",
        scanLink: "https://blockscout.com/astar/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/astar/a827be92d88617a918ea060a9a6f1572.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.KLAY]: {
        id: 8217,
        serverId: "klay",
        network: "8217",
        name: "Klaytn",
        nativeTokenSymbol: "KLAY",
        nativeTokenAddress: "klay",
        enum: CHAINS_ENUM.KLAY,
        hex: "0x2019",
        scanLink: "https://scope.klaytn.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/klay/1df018b8493cb97c50b7e390ef63cba4.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.RSK]: {
        id: 30,
        serverId: "rsk",
        network: "30",
        name: "RSK",
        nativeTokenSymbol: "RBTC",
        nativeTokenAddress: "rsk",
        enum: CHAINS_ENUM.RSK,
        hex: "0x1e",
        scanLink: "https://explorer.rsk.co/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/rsk/2958b02ef823097b70fac99f39889e2e.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.IOTX]: {
        id: 4689,
        serverId: "iotx",
        network: "4689",
        name: "IoTeX",
        nativeTokenSymbol: "IOTX",
        nativeTokenAddress: "iotx",
        enum: CHAINS_ENUM.IOTX,
        hex: "0x1251",
        scanLink: "https://iotexscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/iotx/d3be2cd8677f86bd9ab7d5f3701afcc9.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.KCC]: {
        id: 321,
        serverId: "kcc",
        network: "321",
        name: "KCC",
        nativeTokenSymbol: "KCS",
        nativeTokenAddress: "kcc",
        enum: CHAINS_ENUM.KCC,
        hex: "0x141",
        scanLink: "https://explorer.kcc.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/kcc/3a5a4ef7d5f1db1e53880d70219d75b6.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.WAN]: {
        id: 888,
        serverId: "wan",
        network: "888",
        name: "Wanchain",
        nativeTokenSymbol: "WAN",
        nativeTokenAddress: "wan",
        enum: CHAINS_ENUM.WAN,
        hex: "0x378",
        scanLink: "https://www.wanscan.org/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/wan/f3aa8b31414732ea5e026e05665146e6.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.SGB]: {
        id: 19,
        serverId: "sgb",
        network: "19",
        name: "Songbird",
        nativeTokenSymbol: "SGB",
        nativeTokenAddress: "sgb",
        enum: CHAINS_ENUM.SGB,
        hex: "0x13",
        scanLink: "https://songbird-explorer.flare.network/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/sgb/619f46d574d62a50bdfd9f0e2f47ddc1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.EVMOS]: {
        id: 9001,
        serverId: "evmos",
        network: "9001",
        name: "Evmos",
        nativeTokenSymbol: "EVMOS",
        nativeTokenAddress: "evmos",
        enum: CHAINS_ENUM.EVMOS,
        hex: "0x2329",
        scanLink: "https://escan.live/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/evmos/26e038b4d5475d5a4b92f7fc08bdabc9.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.DFK]: {
        id: 53935,
        serverId: "dfk",
        network: "53935",
        name: "DFK",
        nativeTokenSymbol: "JEWEL",
        nativeTokenAddress: "dfk",
        enum: CHAINS_ENUM.DFK,
        hex: "0xd2af",
        scanLink: "https://subnets.avax.network/defi-kingdoms/dfk-chain/explorer/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/dfk/233867c089c5b71be150aa56003f3f7a.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.TLOS]: {
        id: 40,
        serverId: "tlos",
        network: "40",
        name: "Telos",
        nativeTokenSymbol: "TLOS",
        nativeTokenAddress: "tlos",
        enum: CHAINS_ENUM.TLOS,
        hex: "0x28",
        scanLink: "https://www.teloscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/telos/f9f7493def4c08ed222540bebd8ce87a.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.NOVA]: {
        id: 42170,
        serverId: "nova",
        network: "42170",
        name: "Arbitrum Nova",
        nativeTokenSymbol: "ETH",
        nativeTokenAddress: "nova",
        enum: CHAINS_ENUM.NOVA,
        hex: "0xa4ba",
        scanLink: "https://nova.arbiscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/nova/06eb2b7add8ba443d5b219c04089c326.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.CANTO]: {
        id: 7700,
        serverId: "canto",
        network: "7700",
        name: "Canto",
        nativeTokenSymbol: "Canto",
        nativeTokenAddress: "canto",
        enum: CHAINS_ENUM.CANTO,
        hex: "0x1e14",
        scanLink: "https://tuber.build/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/canto/47574ef619e057d2c6bbce1caba57fb6.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.DOGE]: {
        id: 2000,
        serverId: "doge",
        network: "2000",
        name: "Dogechain",
        nativeTokenSymbol: "wDOGE",
        nativeTokenAddress: "doge",
        enum: CHAINS_ENUM.DOGE,
        hex: "0x7d0",
        scanLink: "https://explorer.dogechain.dog/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/doge/2538141079688a7a43bc22c7b60fb45f.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.STEP]: {
        id: 1234,
        serverId: "step",
        network: "1234",
        name: "Step",
        nativeTokenSymbol: "FITFI",
        nativeTokenAddress: "step",
        enum: CHAINS_ENUM.STEP,
        hex: "0x4d2",
        scanLink: "https://stepscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/step/db79600b8feafe17845617ca9c606dbe.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.KAVA]: {
        id: 2222,
        serverId: "kava",
        network: "2222",
        name: "Kava",
        nativeTokenSymbol: "KAVA",
        nativeTokenAddress: "kava",
        enum: CHAINS_ENUM.KAVA,
        hex: "0x8ae",
        scanLink: "https://explorer.kava.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/step/a09a84faa6fc54a5c86dd41eccd4f9d1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.MADA]: {
        id: 2001,
        serverId: "mada",
        network: "2001",
        name: "Milkomeda",
        nativeTokenSymbol: "milkADA",
        nativeTokenAddress: "mada",
        enum: CHAINS_ENUM.MADA,
        hex: "0x7d1",
        scanLink: "https://explorer-mainnet-cardano-evm.c1.milkomeda.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/mada/cdc4b1112c2c5a2757cbda33f4476b7f.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.CFX]: {
        id: 1030,
        serverId: "cfx",
        network: "1030",
        name: "Conflux",
        nativeTokenSymbol: "CFX",
        nativeTokenAddress: "cfx",
        enum: CHAINS_ENUM.CFX,
        hex: "0x406",
        scanLink: "https://evm.confluxscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/cfx/eab0c7304c6820b48b2a8d0930459b82.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.BRISE]: {
        id: 32520,
        serverId: "brise",
        network: "32520",
        name: "Bitgert",
        nativeTokenSymbol: "BRISE",
        nativeTokenAddress: "brise",
        enum: CHAINS_ENUM.BRISE,
        hex: "0x7f08",
        scanLink: "https://brisescan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/brise/4f6c040cf49f4d8c4eabbad7cd2f4ae4.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.CKB]: {
        id: 71402,
        serverId: "ckb",
        network: "71402",
        name: "Godwoken",
        nativeTokenSymbol: "CKB",
        nativeTokenAddress: "ckb",
        enum: CHAINS_ENUM.CKB,
        hex: "0x116ea",
        scanLink: "https://gwscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/ckb/e821893503104870d5e73f56dbd73746.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.TOMB]: {
        id: 6969,
        serverId: "tomb",
        network: "6969",
        name: "Tomb Chain",
        nativeTokenSymbol: "TOMB",
        nativeTokenAddress: "tomb",
        enum: CHAINS_ENUM.TOMB,
        hex: "0x1b39",
        scanLink: "https://tombscout.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/tomb/eee88f95c46faa10762514b44655a6a1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.PZE]: {
        id: 1101,
        serverId: "pze",
        network: "1101",
        name: "Polygon zkEVM",
        nativeTokenSymbol: "ETH",
        nativeTokenAddress: "pze",
        enum: CHAINS_ENUM.PZE,
        hex: "0x44d",
        scanLink: "https://zkevm.polygonscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/pze/a2276dce2d6a200c6148fb975f0eadd3.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.ERA]: {
        id: 324,
        serverId: "era",
        network: "324",
        name: "zkSync Era",
        nativeTokenSymbol: "ETH",
        nativeTokenAddress: "era",
        enum: CHAINS_ENUM.ERA,
        hex: "0x144",
        scanLink: "https://era.zksync.network/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/era/e21641a19fe6b8c5d05337dacae17b6e.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.EOS]: {
        id: 17777,
        serverId: "eos",
        network: "17777",
        name: "EOS EVM",
        nativeTokenSymbol: "EOS",
        nativeTokenAddress: "eos",
        enum: CHAINS_ENUM.EOS,
        hex: "0x4571",
        scanLink: "https://explorer.evm.eosnetwork.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/eos/7e3122a9ce6f9d522e6d5519d43b6a72.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.CORE]: {
        id: 1116,
        serverId: "core",
        network: "1116",
        name: "CORE",
        nativeTokenSymbol: "CORE",
        nativeTokenAddress: "core",
        enum: CHAINS_ENUM.CORE,
        hex: "0x45c",
        scanLink: "https://scan.coredao.org/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/core/ccc02f660e5dd410b23ca3250ae7c060.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.FLR]: {
        id: 14,
        serverId: "flr",
        network: "14",
        name: "Flare",
        nativeTokenSymbol: "FLR",
        nativeTokenAddress: "flr",
        enum: CHAINS_ENUM.FLR,
        hex: "0xe",
        scanLink: "https://flare-explorer.flare.network/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/flr/9ee03d5d7036ad9024e81d55596bb4dc.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.WEMIX]: {
        id: 1111,
        serverId: "wemix",
        network: "1111",
        name: "WEMIX",
        nativeTokenSymbol: "WEMIX",
        nativeTokenAddress: "wemix",
        enum: CHAINS_ENUM.WEMIX,
        hex: "0x457",
        scanLink: "https://explorer.wemix.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/wemix/d1ba88d1df6cca0b0cb359c36a09c054.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.METER]: {
        id: 82,
        serverId: "mtr",
        network: "82",
        name: "Meter",
        nativeTokenSymbol: "MTR",
        nativeTokenAddress: "mtr",
        enum: CHAINS_ENUM.METER,
        hex: "0x52",
        scanLink: "https://scan.meter.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/mtr/2dc6f079f52ca22778eb684e1ce650b3.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.ETC]: {
        id: 61,
        serverId: "etc",
        network: "61",
        name: "Ethereum Classic",
        nativeTokenSymbol: "ETC",
        nativeTokenAddress: "etc",
        enum: CHAINS_ENUM.ETC,
        hex: "0x3d",
        scanLink: "https://blockscout.com/etc/mainnet/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/etc/7ccf90ee6822ab440fb603337da256fa.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.FSN]: {
        id: 32659,
        serverId: "fsn",
        network: "32659",
        name: "Fusion",
        nativeTokenSymbol: "FSN",
        nativeTokenAddress: "fsn",
        enum: CHAINS_ENUM.FSN,
        hex: "0x7f93",
        scanLink: "https://fsnscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/fsn/047789979f0b5733602b29517753bdf3.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.PULSE]: {
        id: 369,
        serverId: "pls",
        network: "369",
        name: "Pulse",
        nativeTokenSymbol: "PLS",
        nativeTokenAddress: "pls",
        enum: CHAINS_ENUM.PULSE,
        hex: "0x171",
        scanLink: "https://scan.mypinata.cloud/ipfs/bafybeidn64pd2u525lmoipjl4nh3ooa2imd7huionjsdepdsphl5slfowy/#/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/pls/aa6be079fa9eb568e02150734ebb3db0.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.ROSE]: {
        id: 42262,
        serverId: "rose",
        network: "42262",
        name: "Oasis Emerald",
        nativeTokenSymbol: "ROSE",
        nativeTokenAddress: "rose",
        enum: CHAINS_ENUM.ROSE,
        hex: "0xa516",
        scanLink: "https://explorer.emerald.oasis.dev/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/rose/33ade55b0f3efa10e9eec002c6417257.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.RONIN]: {
        id: 2020,
        serverId: "ron",
        network: "2020",
        name: "Ronin",
        nativeTokenSymbol: "RON",
        nativeTokenAddress: "ron",
        enum: CHAINS_ENUM.RONIN,
        hex: "0x7e4",
        scanLink: "https://explorer.roninchain.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/ron/6e0f509804bc83bf042ef4d674c1c5ee.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.OAS]: {
        id: 248,
        serverId: "oas",
        network: "248",
        name: "Oasys",
        nativeTokenSymbol: "OAS",
        nativeTokenAddress: "oas",
        enum: CHAINS_ENUM.OAS,
        hex: "0xf8",
        scanLink: "https://scan.oasys.games/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/oas_token/logo_url/oas/322b2cb0935af95b9cabd8a59b629566.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.ZORA]: {
        id: 7777777,
        serverId: "zora",
        network: "7777777",
        name: "Zora",
        nativeTokenSymbol: "ETH",
        nativeTokenAddress: "zora",
        enum: CHAINS_ENUM.ZORA,
        hex: "0x76adf1",
        scanLink: "https://explorer.zora.energy/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/token/logo_url/eth/935ae4e4d1d12d59a99717a24f2540b5.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.LINEA]: {
        id: 59144,
        serverId: "linea",
        network: "59144",
        name: "Linea",
        nativeTokenSymbol: "ETH",
        nativeTokenAddress: "linea",
        enum: CHAINS_ENUM.LINEA,
        hex: "0xe708",
        scanLink: "https://lineascan.build/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/token/logo_url/eth/935ae4e4d1d12d59a99717a24f2540b5.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.BASE]: {
        id: 8453,
        serverId: "base",
        network: "8453",
        name: "Base",
        nativeTokenSymbol: "ETH",
        nativeTokenAddress: "base",
        enum: CHAINS_ENUM.BASE,
        hex: "0x2105",
        scanLink: "https://basescan.org/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/token/logo_url/eth/935ae4e4d1d12d59a99717a24f2540b5.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.GETH]: {
        id: 5,
        serverId: "geth",
        network: "5",
        name: "Ethereum Goerli",
        nativeTokenSymbol: "GoerliETH",
        nativeTokenAddress: "geth",
        enum: CHAINS_ENUM.GETH,
        hex: "0x5",
        scanLink: "https://goerli.etherscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/token/logo_url/eth/935ae4e4d1d12d59a99717a24f2540b5.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.GARBITRUM]: {
        id: 421613,
        serverId: "garb",
        name: "Arbitrum Goerli",
        enum: CHAINS_ENUM.GARBITRUM,
        hex: "0x66eed",
        network: "421613",
        nativeTokenSymbol: "GoerliETH",
        nativeTokenAddress: "garb",
        scanLink: "https://testnet.arbiscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/arb_token/logo_url/arb/d61441782d4a08a7479d54aea211679e.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.CGNOSIS]: {
        id: 10200,
        name: "Gnosis Chiado",
        serverId: "cxdai",
        hex: "0x27d8",
        enum: CHAINS_ENUM.CGNOSIS,
        network: "10200",
        nativeTokenSymbol: "ChiadoXDAI",
        nativeTokenAddress: "cxdai",
        scanLink: "https://gnosis-chiado.blockscout.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/xdai_token/logo_url/xdai/1207e67652b691ef3bfe04f89f4b5362.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.MANTLE]: {
        id: 5000,
        name: "Mantle",
        serverId: "mnt",
        hex: "0x1388",
        enum: CHAINS_ENUM.MANTLE,
        network: "5000",
        nativeTokenSymbol: "MNT",
        nativeTokenAddress: "mnt",
        scanLink: "https://explorer.mantle.xyz/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/mnt/0af11a52431d60ded59655c7ca7e1475.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
    },
    [CHAINS_ENUM.TENET]: {
        id: 1559,
        name: "Tenet",
        serverId: "tenet",
        hex: "0x617",
        enum: CHAINS_ENUM.TENET,
        network: "1559",
        nativeTokenSymbol: "TENET",
        nativeTokenAddress: "tenet",
        scanLink: "https://tenetscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/tenet/803be22e467ee9a5abe00d69a9c3ea4f.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
    },
    [CHAINS_ENUM.TBSC]: {
        id: 97,
        name: "BNB Testnet",
        serverId: "tbsc",
        hex: "0x61",
        enum: CHAINS_ENUM.TBSC,
        network: "97",
        nativeTokenSymbol: "TestnetBNB",
        nativeTokenAddress: "tbsc",
        scanLink: "https://testnet.bscscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/bsc_token/logo_url/bsc/8bfdeaa46fe9be8f5cd43a53b8d1eea1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.MPOLYGON]: {
        id: 80001,
        serverId: "mmatic",
        name: "Polygon Mumbai",
        hex: "0x13881",
        enum: CHAINS_ENUM.MPOLYGON,
        network: "80001",
        nativeTokenSymbol: "MumbaiMATIC",
        nativeTokenAddress: "mmatic",
        nativeTokenDecimals: 18,
        scanLink: "https://mumbai.polygonscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/matic_token/logo_url/matic/e5a8a2860ba5cf740a474dcab796dc63.png",
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.GOP]: {
        id: 420,
        serverId: "gop",
        network: "420",
        name: "Optimism Goerli",
        enum: CHAINS_ENUM.GOP,
        hex: "0x1a4",
        scanLink: "https://goerli-optimism.etherscan.io/tx/_s_",
        nativeTokenSymbol: "GoerliETH",
        nativeTokenAddress: "gop",
        nativeTokenLogo: "https://static.debank.com/image/op_token/logo_url/op/d61441782d4a08a7479d54aea211679e.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.GBOBA]: {
        id: 2888,
        serverId: "gboba",
        network: "2888",
        name: "Boba Goerli",
        nativeTokenSymbol: "GoerliETH",
        nativeTokenAddress: "gboba",
        enum: CHAINS_ENUM.GBOBA,
        hex: "0xb48",
        scanLink: "https://testnet.bobascan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/token/logo_url/eth/935ae4e4d1d12d59a99717a24f2540b5.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.GBASE]: {
        id: 84531,
        serverId: "gbase",
        network: "84531",
        name: "Base Goerli",
        nativeTokenSymbol: "GoerliETH",
        nativeTokenAddress: "gbase",
        enum: CHAINS_ENUM.GBASE,
        hex: "0x14a33",
        scanLink: "https://goerli.basescan.org/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/token/logo_url/eth/935ae4e4d1d12d59a99717a24f2540b5.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.GLINEA]: {
        id: 59140,
        serverId: "glinea",
        network: "59140",
        name: "Linea Goerli",
        nativeTokenSymbol: "GoerliETH",
        nativeTokenAddress: "glinea",
        enum: CHAINS_ENUM.GLINEA,
        hex: "0xe704",
        scanLink: "https://explorer.goerli.linea.build/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/token/logo_url/eth/935ae4e4d1d12d59a99717a24f2540b5.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TFTM]: {
        id: 4002,
        serverId: "tftm",
        network: "4002",
        name: "Fantom Testnet",
        nativeTokenSymbol: "TestnetFTM",
        nativeTokenAddress: "tftm",
        enum: CHAINS_ENUM.TFTM,
        hex: "0xfa2",
        scanLink: "https://testnet.ftmscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/tftm/d2f3315db5ff227373d10e6b68968ee9.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TLYX]: {
        id: 4201,
        serverId: "tlyx",
        network: "4201",
        name: "LUKSO Testnet",
        nativeTokenSymbol: "TestnetLYX",
        nativeTokenAddress: "tlyx",
        enum: CHAINS_ENUM.TLYX,
        hex: "0x1069",
        scanLink: "https://explorer.execution.testnet.lukso.network/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/tlyx/52d17f7faf8e52eaf64fda2ab8cd06c4.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.LYX]: {
        id: 42,
        serverId: "lyx",
        network: "42",
        name: "LUKSO",
        nativeTokenSymbol: "LYX",
        nativeTokenAddress: "lyx",
        enum: CHAINS_ENUM.LYX,
        hex: "0x2a",
        scanLink: "https://explorer.execution.mainnet.lukso.network/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/lyx/dbe6eef57e66817e61297d9b188248ed.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.TDEBANK]: {
        id: 2021398,
        serverId: "tdbk",
        network: "2021398",
        name: "DeBank Testnet",
        nativeTokenSymbol: "USD",
        nativeTokenAddress: "tdbk",
        enum: CHAINS_ENUM.TDEBANK,
        hex: "0x1ed816",
        scanLink: "https://explorer.testnet.debank.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tdbk_token/logo_url/tdbk/ca33ab4b12ff60ed4b571334a251d45e.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TMNT]: {
        id: 5001,
        serverId: "tmnt",
        network: "5001",
        name: "Mantle Testnet",
        nativeTokenSymbol: "TestnetMNT",
        nativeTokenAddress: "tmnt",
        enum: CHAINS_ENUM.TMNT,
        hex: "0x1389",
        scanLink: "https://explorer.testnet.mantle.xyz/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/tmnt/4c5f5bc84f7cbfe80b6be29021898a51.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.OPBNB]: {
        id: 204,
        serverId: "opbnb",
        network: "204",
        name: "opBNB",
        nativeTokenSymbol: "BNB",
        nativeTokenAddress: "opbnb",
        enum: CHAINS_ENUM.OPBNB,
        hex: "0xcc",
        scanLink: "https://mainnet.opbnbscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/bsc_token/logo_url/bsc/8bfdeaa46fe9be8f5cd43a53b8d1eea1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.GERA]: {
        id: 280,
        serverId: "gera",
        network: "280",
        name: "zkSync Era Goerli",
        nativeTokenSymbol: "GoerliETH",
        nativeTokenAddress: "gera",
        enum: CHAINS_ENUM.GERA,
        hex: "0x118",
        scanLink: "https://goerli.explorer.zksync.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/token/logo_url/eth/935ae4e4d1d12d59a99717a24f2540b5.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.PMANTA]: {
        id: 3441005,
        serverId: "pmanta",
        network: "3441005",
        name: "Manta Pacific Testnet",
        nativeTokenSymbol: "PacificETH",
        nativeTokenAddress: "pmanta",
        enum: CHAINS_ENUM.PMANTA,
        hex: "0x34816d",
        scanLink: "https://pacific-explorer.manta.network/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/token/logo_url/eth/935ae4e4d1d12d59a99717a24f2540b5.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TOPBNB]: {
        id: 5611,
        serverId: "topbnb",
        network: "5611",
        name: "opBNB Testnet",
        nativeTokenSymbol: "TestnetBNB",
        nativeTokenAddress: "topbnb",
        enum: CHAINS_ENUM.TOPBNB,
        hex: "0x15eb",
        scanLink: "https://opbnbscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/coin/logo_url/bnb/9784283a36f23a58982fc964574ea530.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TTENET]: {
        id: 155,
        name: "Tenet Testnet",
        serverId: "ttenet",
        hex: "0x9b",
        enum: CHAINS_ENUM.TTENET,
        network: "155",
        nativeTokenSymbol: "TestnetTENET",
        nativeTokenAddress: "ttenet",
        scanLink: "https://testnet.tenetscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tenet_token/logo_url/tenet/2da9b626102a7de9625aaf753cfac321.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.LOOT]: {
        id: 5151706,
        name: "Loot",
        serverId: "loot",
        hex: "0x4e9bda",
        enum: CHAINS_ENUM.LOOT,
        network: "5151706",
        nativeTokenSymbol: "AGLD",
        nativeTokenAddress: "loot",
        scanLink: "https://explorer.lootchain.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/loot_token/logo_url/loot/a6c0dc128d515e2d32526075decae9ec.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.TLOOT]: {
        id: 9088912,
        name: "Loot Testnet",
        serverId: "tloot",
        hex: "0x8aaf90",
        enum: CHAINS_ENUM.TLOOT,
        network: "9088912",
        nativeTokenSymbol: "TestnetAGLD",
        nativeTokenAddress: "tloot",
        scanLink: "https://testnet.explorer.lootchain.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tloot_token/logo_url/tloot/a6c0dc128d515e2d32526075decae9ec.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.SETH]: {
        id: 11155111,
        serverId: "seth",
        network: "11155111",
        name: "Ethereum Sepolia",
        nativeTokenSymbol: "SepoliaETH",
        nativeTokenAddress: "seth",
        enum: CHAINS_ENUM.SETH,
        hex: "0xaa36a7",
        scanLink: "https://sepolia.etherscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/seth_token/logo_url/seth/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.SSCROLL]: {
        id: 534351,
        serverId: "sscrl",
        network: "534351",
        name: "Scroll Sepolia",
        nativeTokenSymbol: "SepoliaETH",
        nativeTokenAddress: "sscrl",
        enum: CHAINS_ENUM.SSCROLL,
        hex: "0x8274f",
        scanLink: "https://sepolia-blockscout.scroll.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/sscrl_token/logo_url/sscrl/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.AZETA]: {
        id: 7001,
        serverId: "azeta",
        network: "7001",
        name: "ZetaChain Athens-3 Testnet",
        nativeTokenSymbol: "AthensZETA",
        nativeTokenAddress: "azeta",
        enum: CHAINS_ENUM.AZETA,
        hex: "0x1b59",
        scanLink: "https://zetachain-athens-3.blockscout.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/azeta_token/logo_url/azeta/67a3cca2e34f8ff6fadfd339dac7a207.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TALT]: {
        id: 9997,
        serverId: "talt",
        network: "9997",
        name: "AltLayer Testnet",
        nativeTokenSymbol: "TestnetETH",
        nativeTokenAddress: "talt",
        enum: CHAINS_ENUM.TALT,
        hex: "0x270d",
        scanLink: "https://testnet-rollup-explorer.altlayer.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/talt_token/logo_url/talt/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.GZORA]: {
        id: 999,
        serverId: "gzora",
        network: "999",
        name: "Zora Goerli",
        nativeTokenSymbol: "GoerliETH",
        nativeTokenAddress: "gzora",
        enum: CHAINS_ENUM.GZORA,
        hex: "0x3e7",
        scanLink: "https://testnet.explorer.zora.energy/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/gzora_token/logo_url/gzora/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.SHIB]: {
        id: 109,
        serverId: "shib",
        network: "109",
        name: "Shibarium",
        nativeTokenSymbol: "BONE",
        nativeTokenAddress: "shib",
        enum: CHAINS_ENUM.SHIB,
        hex: "0x6d",
        scanLink: "https://www.shibariumscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/shib_token/logo_url/shib/e49e9a98f5fb1fb04ad96bb536457df9.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.TAVAX]: {
        id: 43113,
        serverId: "tavax",
        network: "43113",
        name: "Avalanche Testnet",
        nativeTokenSymbol: "TestnetAVAX",
        nativeTokenAddress: "tavax",
        enum: CHAINS_ENUM.TAVAX,
        hex: "0xa869",
        scanLink: "https://testnet.snowtrace.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tavax_token/logo_url/tavax/23248222bdb3e6f3b63efbc4270d2feb.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.PSHIB]: {
        id: 719,
        serverId: "pshib",
        network: "719",
        name: "Shibarium Puppynet Testnet",
        nativeTokenSymbol: "PuppynetBONE",
        nativeTokenAddress: "pshib",
        enum: CHAINS_ENUM.PSHIB,
        hex: "0x2cf",
        scanLink: "https://puppyscan.shib.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/pshib_token/logo_url/pshib/e49e9a98f5fb1fb04ad96bb536457df9.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.GMETIS]: {
        id: 599,
        serverId: "gmetis",
        network: "599",
        name: "Metis Goerli",
        nativeTokenSymbol: "GoerliMETIS",
        nativeTokenAddress: "gmetis",
        enum: CHAINS_ENUM.GMETIS,
        hex: "0x257",
        scanLink: "https://goerli.explorer.metisdevops.link/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/gmetis_token/logo_url/gmetis/d2da264b0b9f038efe9ae94e73b1a2b3.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.SARB]: {
        id: 421614,
        serverId: "sarb",
        name: "Arbitrum Sepolia",
        enum: CHAINS_ENUM.SARB,
        hex: "0x66eee",
        network: "421614",
        nativeTokenSymbol: "SepoliaETH",
        nativeTokenAddress: "sarb",
        scanLink: "https://sepolia-explorer.arbitrum.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/sarb_token/logo_url/sarb/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TSTLS]: {
        id: 23011913,
        serverId: "tstls",
        name: "Stylus Testnet",
        enum: CHAINS_ENUM.TSTLS,
        hex: "0x15f2249",
        network: "23011913",
        nativeTokenSymbol: "StylusETH",
        nativeTokenAddress: "tstls",
        scanLink: "https://stylus-testnet-explorer.arbitrum.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tstls_token/logo_url/tstls/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.CFLR]: {
        id: 114,
        serverId: "cflr",
        name: "Flare Coston2 Testnet",
        enum: CHAINS_ENUM.CFLR,
        hex: "0x72",
        network: "114",
        nativeTokenSymbol: "CostonFLR",
        nativeTokenAddress: "cflr",
        scanLink: "https://coston2-explorer.flare.network/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/cflr_token/logo_url/cflr/6db879abe221aba6c3e9c17bc0ae8027.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.ACELO]: {
        id: 44787,
        serverId: "acelo",
        name: "Celo Alfajores Testnet",
        enum: CHAINS_ENUM.ACELO,
        hex: "0xaef3",
        network: "44787",
        nativeTokenSymbol: "AlfajoresCELO",
        nativeTokenAddress: "acelo",
        scanLink: "https://alfajores.celoscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/acelo_token/logo_url/acelo/e185898e9de453b6ac856cefd73ac705.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.DBTT]: {
        id: 1029,
        serverId: "dbtt",
        name: "BitTorrent Donau Testnet",
        enum: CHAINS_ENUM.DBTT,
        hex: "0x405",
        network: "1029",
        nativeTokenSymbol: "DonauBTT",
        nativeTokenAddress: "dbtt",
        scanLink: "https://testnet.bttcscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/dbtt_token/logo_url/dbtt/8001322865f15cfa4602d79bb6ba16c0.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TEVMOS]: {
        id: 9000,
        serverId: "tevmos",
        name: "EvmOS Testnet",
        enum: CHAINS_ENUM.TEVMOS,
        hex: "0x2328",
        network: "9000",
        nativeTokenSymbol: "TestnetEVMOS",
        nativeTokenAddress: "tevmos",
        scanLink: "https://testnet.escan.live/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tevmos_token/logo_url/tevmos/e5db0fb435216c9d7253dfb5daa89052.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.MANTA]: {
        id: 169,
        serverId: "manta",
        name: "Manta Pacific",
        enum: CHAINS_ENUM.MANTA,
        hex: "0xa9",
        network: "169",
        nativeTokenSymbol: "ETH",
        nativeTokenAddress: "manta",
        scanLink: "https://pacific-explorer.manta.network/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/manta_token/logo_url/manta/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.TDFK]: {
        id: 335,
        serverId: "tdfk",
        name: "DFK Testnet",
        enum: CHAINS_ENUM.TDFK,
        hex: "0x14f",
        network: "335",
        nativeTokenSymbol: "TestnetJEWEL",
        nativeTokenAddress: "tdfk",
        scanLink: "https://subnets-test.avax.network/defi-kingdoms/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tdfk_token/logo_url/tdfk/10b392350abce30ee2d49f78c42b2f2e.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TWEMIX]: {
        id: 1112,
        serverId: "twemix",
        name: "WEMIX Testnet",
        enum: CHAINS_ENUM.TWEMIX,
        hex: "0x458",
        network: "1112",
        nativeTokenSymbol: "TestnetWEMIX",
        nativeTokenAddress: "twemix",
        scanLink: "https://explorer.test.wemix.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/twemix_token/logo_url/twemix/9fb2c3e6f376e29813a8f3d5ac1edfb9.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TSTEP]: {
        id: 12345,
        serverId: "tstep",
        name: "Step Testnet",
        enum: CHAINS_ENUM.TSTEP,
        hex: "0x3039",
        network: "12345",
        nativeTokenSymbol: "TestnetFITFI",
        nativeTokenAddress: "tstep",
        scanLink: "https://testnet.stepscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tstep_token/logo_url/tstep/9d345f7e03f078657bb1ffd494442d67.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.METC]: {
        id: 63,
        serverId: "metc",
        name: "Ethereum Classic Mordor Testnet",
        enum: CHAINS_ENUM.METC,
        hex: "0x3f",
        network: "63",
        nativeTokenSymbol: "MordorETC",
        nativeTokenAddress: "metc",
        scanLink: "https://blockscout.com/etc/mordor/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/metc_token/logo_url/metc/782943aff604f69c7889d90926348210.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TFSN]: {
        id: 46688,
        serverId: "tfsn",
        name: "Fusion Testnet",
        enum: CHAINS_ENUM.TFSN,
        hex: "0xb660",
        network: "46688",
        nativeTokenSymbol: "TestnetFSN",
        nativeTokenAddress: "tfsn",
        scanLink: "https://testnet.fsnscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tfsn_token/logo_url/tfsn/914f67e69113f079caa0fad50e0b3412.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.AMOBM]: {
        id: 1287,
        serverId: "amobm",
        name: "Moonbase Alpha Testnet",
        enum: CHAINS_ENUM.AMOBM,
        hex: "0x507",
        network: "1287",
        nativeTokenSymbol: "DEV",
        nativeTokenAddress: "amobm",
        scanLink: "https://moonbase.moonscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/amobm_token/logo_url/amobm/d6b7e1647ea672fe9a92927d3157263e.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TKCC]: {
        id: 322,
        serverId: "tkcc",
        name: "KCC Testnet",
        enum: CHAINS_ENUM.TKCC,
        hex: "0x142",
        network: "322",
        nativeTokenSymbol: "TestnetKCS",
        nativeTokenAddress: "tkcc",
        scanLink: "https://scan-testnet.kcc.network/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tkcc_token/logo_url/tkcc/9c884acf5fb6d38faa595eb24f640121.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TIOTX]: {
        id: 4690,
        serverId: "tiotx",
        name: "IoTeX Testnet",
        enum: CHAINS_ENUM.TIOTX,
        hex: "0x1252",
        network: "4690",
        nativeTokenSymbol: "TestnetIOTX",
        nativeTokenAddress: "tiotx",
        scanLink: "https://testnet.iotexscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tiotx_token/logo_url/tiotx/5982dfa001f2a6e43617a51ac7b2d011.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TPLS]: {
        id: 943,
        serverId: "tpls",
        name: "Pulse V4 Testnet",
        enum: CHAINS_ENUM.TPLS,
        hex: "0x3af",
        network: "943",
        nativeTokenSymbol: "TestnetPLS",
        nativeTokenAddress: "tpls",
        scanLink: "https://scan.v4.testnet.pulsechain.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tpls_token/logo_url/tpls/28a0e357df556b82bb9e8cd30f2c258a.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.HETH]: {
        id: 17000,
        serverId: "heth",
        name: "Ethereum Holesky",
        enum: CHAINS_ENUM.HETH,
        hex: "0x4268",
        network: "17000",
        nativeTokenSymbol: "HoleskyETH",
        nativeTokenAddress: "heth",
        scanLink: "https://holesky.etherscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/heth_token/logo_url/heth/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.BKLAY]: {
        id: 1001,
        serverId: "bklay",
        name: "Klaytn Baobab Testnet",
        enum: CHAINS_ENUM.BKLAY,
        hex: "0x3e9",
        network: "1001",
        nativeTokenSymbol: "BaobabKLAY",
        nativeTokenAddress: "bklay",
        scanLink: "https://baobab.scope.klaytn.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/bklay_token/logo_url/bklay/1866fc790849a903e0594ce0f55b758d.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.CSGB]: {
        id: 16,
        serverId: "csgb",
        name: "Songbird Coston Testnet",
        enum: CHAINS_ENUM.CSGB,
        hex: "0x10",
        network: "16",
        nativeTokenSymbol: "CostonFLR",
        nativeTokenAddress: "csgb",
        scanLink: "https://coston-explorer.flare.network/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/csgb_token/logo_url/csgb/6db879abe221aba6c3e9c17bc0ae8027.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TKAVA]: {
        id: 2221,
        serverId: "tkava",
        name: "Kava Testnet",
        enum: CHAINS_ENUM.TKAVA,
        hex: "0x8ad",
        network: "2221",
        nativeTokenSymbol: "TestnetKAVA",
        nativeTokenAddress: "tkava",
        scanLink: "https://testnet.kavascan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tkava_token/logo_url/tkava/d6a35171eb8e7711e22bd408c44b85bf.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.SCRL]: {
        id: 534352,
        serverId: "scrl",
        name: "Scroll",
        enum: CHAINS_ENUM.SCRL,
        hex: "0x82750",
        network: "534352",
        nativeTokenSymbol: "ETH",
        nativeTokenAddress: "scrl",
        scanLink: "https://scrollscan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/scrl_token/logo_url/scrl/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.FX]: {
        id: 530,
        serverId: "fx",
        name: "Function X",
        enum: CHAINS_ENUM.FX,
        hex: "0x212",
        network: "530",
        nativeTokenSymbol: "FX",
        nativeTokenAddress: "fx",
        scanLink: "https://starscan.io/evm/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/fx_token/logo_url/fx/6fee82420b2394e0b68d7d7e692a0a01.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.DFX]: {
        id: 90001,
        serverId: "dfx",
        name: "Function X Dhobyghaut Testnet",
        enum: CHAINS_ENUM.DFX,
        hex: "0x15f91",
        network: "90001",
        nativeTokenSymbol: "DhobyghautFX",
        nativeTokenAddress: "dfx",
        scanLink: "https://testnet.starscan.io/evm/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/dfx_token/logo_url/dfx/6fee82420b2394e0b68d7d7e692a0a01.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TAURORA]: {
        id: 1313161555,
        serverId: "taurora",
        name: "Aurora Testnet",
        enum: CHAINS_ENUM.TAURORA,
        hex: "0x4e454153",
        network: "1313161555",
        nativeTokenSymbol: "TestnetETH",
        nativeTokenAddress: "taurora",
        scanLink: "https://explorer.testnet.aurora.dev/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/taurora_token/logo_url/taurora/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TCRO]: {
        id: 338,
        serverId: "tcro",
        name: "Cronos Testnet",
        enum: CHAINS_ENUM.TCRO,
        hex: "0x152",
        network: "338",
        nativeTokenSymbol: "TestnetCRO",
        nativeTokenAddress: "tcro",
        scanLink: "https://explorer.cronos.org/testnet/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tcro_token/logo_url/tcro/7803de9b434be197c2c1399465abdf39.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.SMODE]: {
        id: 919,
        serverId: "smode",
        name: "Mode Sepolia Testnet",
        enum: CHAINS_ENUM.SMODE,
        hex: "0x397",
        network: "919",
        nativeTokenSymbol: "SepoliaETH",
        nativeTokenAddress: "smode",
        scanLink: "https://sepolia.explorer.mode.network/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/smode_token/logo_url/smode/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TIMXZE]: {
        id: 13472,
        serverId: "timxze",
        name: "Immutable zkEVM Testnet",
        enum: CHAINS_ENUM.TIMXZE,
        hex: "0x34a0",
        network: "13472",
        nativeTokenSymbol: "TestnetIMX",
        nativeTokenAddress: "timxze",
        scanLink: "https://explorer.testnet.immutable.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/timxze_token/logo_url/timxze/00b44115674fd159771862e3aedeaf9d.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.KTAIKO]: {
        id: 167008,
        serverId: "ktaiko",
        name: "Taiko Katla Testnet",
        enum: CHAINS_ENUM.KTAIKO,
        hex: "0x28c60",
        network: "167008",
        nativeTokenSymbol: "KatlaETH",
        nativeTokenAddress: "ktaiko",
        scanLink: "https://explorer.katla.taiko.xyz/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/ktaiko_token/logo_url/ktaiko/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.SSYNP]: {
        id: 444,
        serverId: "ssynp",
        name: "Synapse Sepolia",
        enum: CHAINS_ENUM.SSYNP,
        hex: "0x1bc",
        network: "444",
        nativeTokenSymbol: "SepoliaETH",
        nativeTokenAddress: "ssynp",
        scanLink: "https://sepolia.synapsescan.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/ssynp_token/logo_url/ssynp/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TCFX]: {
        id: 71,
        serverId: "tcfx",
        name: "Conflux Testnet",
        enum: CHAINS_ENUM.TCFX,
        hex: "0x47",
        network: "71",
        nativeTokenSymbol: "TestnetCFX",
        nativeTokenAddress: "tcfx",
        scanLink: "https://evmtestnet.confluxscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tcfx_token/logo_url/tcfx/fd57922224e5cbfc786f4e137397f162.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TX1]: {
        id: 195,
        serverId: "tx1",
        name: "X1 Testnet",
        enum: CHAINS_ENUM.TX1,
        hex: "0xc3",
        network: "195",
        nativeTokenSymbol: "TestnetOKB",
        nativeTokenAddress: "tx1",
        scanLink: "https://www.oklink.com/x1-test/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tx1_token/logo_url/tx1/02e2fec5f8b2f5783ceb38d683557de3.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TSBY]: {
        id: 81,
        serverId: "tsby",
        name: "Astar Shibuya Testnet",
        enum: CHAINS_ENUM.TSBY,
        hex: "0x51",
        network: "81",
        nativeTokenSymbol: "TestnetSBY",
        nativeTokenAddress: "tsby",
        scanLink: "https://blockscout.com/shibuya/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tsby_token/logo_url/tsby/320132256211b78a637825a1d17b290c.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TAZE]: {
        id: 1261120,
        serverId: "taze",
        name: "Astar zKatana Testnet",
        enum: CHAINS_ENUM.TAZE,
        hex: "0x133e40",
        network: "1261120",
        nativeTokenSymbol: "zKatanaETH",
        nativeTokenAddress: "taze",
        scanLink: "https://zkatana.explorer.startale.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/taze_token/logo_url/taze/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.BEAM]: {
        id: 4337,
        serverId: "beam",
        name: "Beam",
        enum: CHAINS_ENUM.BEAM,
        hex: "0x10f1",
        network: "4337",
        nativeTokenSymbol: "BEAM",
        nativeTokenAddress: "beam",
        scanLink: "https://subnets.avax.network/beam/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/beam_token/logo_url/beam/90a1e9f46664d070752deeb65878a3bd.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.TBEAM]: {
        id: 13337,
        serverId: "tbeam",
        name: "Beam Testnet",
        enum: CHAINS_ENUM.TBEAM,
        hex: "0x3419",
        network: "13337",
        nativeTokenSymbol: "TestnetBEAM",
        nativeTokenAddress: "tbeam",
        scanLink: "https://subnets-test.avax.network/beam/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tbeam_token/logo_url/tbeam/90a1e9f46664d070752deeb65878a3bd.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TFRAX]: {
        id: 2522,
        serverId: "tfrax",
        name: "Fraxchain Testnet",
        enum: CHAINS_ENUM.TFRAX,
        hex: "0x9da",
        network: "2522",
        nativeTokenSymbol: "TestnetfrxETH",
        nativeTokenAddress: "tfrax",
        scanLink: "https://explorer.testnet.frax.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tfrax_token/logo_url/tfrax/71b8a5f7684c752901272fb31842abdf.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TPEGO]: {
        id: 123456,
        serverId: "tpego",
        name: "Pego Testnet",
        enum: CHAINS_ENUM.TPEGO,
        hex: "0x1e240",
        network: "123456",
        nativeTokenSymbol: "TestnetPG",
        nativeTokenAddress: "tpego",
        scanLink: "https://scan.pegotest.net/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tpego_token/logo_url/tpego/6b81cf47fdc1b86707d3fbf02f90cf18.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TFRAME]: {
        id: 68840142,
        serverId: "tframe",
        name: "Frame Testnet",
        enum: CHAINS_ENUM.TFRAME,
        hex: "0x41a6ace",
        network: "68840142",
        nativeTokenSymbol: "TestnetETH",
        nativeTokenAddress: "tframe",
        scanLink: "https://explorer.testnet.frame.xyz/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tframe_token/logo_url/tframe/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.PEGO]: {
        id: 20201022,
        serverId: "pego",
        name: "Pego",
        enum: CHAINS_ENUM.PEGO,
        hex: "0x1343e3e",
        network: "20201022",
        nativeTokenSymbol: "PG",
        nativeTokenAddress: "pego",
        scanLink: "https://scan.pego.network/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/pego_token/logo_url/pego/6b81cf47fdc1b86707d3fbf02f90cf18.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.ZKFAIR]: {
        id: 42766,
        serverId: "zkfair",
        name: "ZKFair",
        enum: CHAINS_ENUM.ZKFAIR,
        hex: "0xa70e",
        network: "42766",
        nativeTokenSymbol: "USDC",
        nativeTokenAddress: "zkfair",
        scanLink: "https://scan.zkfair.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/zkfair_token/logo_url/zkfair/35ab0987153a8355a454223aae371ac7.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.TRSK]: {
        id: 31,
        serverId: "trsk",
        name: "RSK Testnet",
        enum: CHAINS_ENUM.TRSK,
        hex: "0x1f",
        network: "31",
        nativeTokenSymbol: "TestnetRBTC",
        nativeTokenAddress: "trsk",
        scanLink: "https://explorer.testnet.rsk.co/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/trsk_token/logo_url/trsk/62608952967d6a6eaecd2702f8143ff8.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.TALOT]: {
        id: 432201,
        serverId: "talot",
        name: "Dexalot Testnet",
        enum: CHAINS_ENUM.TALOT,
        hex: "0x69849",
        network: "432201",
        nativeTokenSymbol: "TestnetALOT",
        nativeTokenAddress: "talot",
        scanLink: "https://subnets-test.avax.network/dexalot/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/talot_token/logo_url/talot/025f0609ce8d1afd70dbd72c316bca04.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.FON]: {
        id: 201022,
        serverId: "fon",
        name: "FON Chain",
        enum: CHAINS_ENUM.FON,
        hex: "0x3113e",
        network: "201022",
        nativeTokenSymbol: "FON",
        nativeTokenAddress: "fon",
        scanLink: "https://fonscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/fon_token/logo_url/fon/369618f4d45053fa4439943c9c2d387d.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.BFC]: {
        id: 3068,
        serverId: "bfc",
        name: "Bifrost",
        enum: CHAINS_ENUM.BFC,
        hex: "0xbfc",
        network: "3068",
        nativeTokenSymbol: "BFC",
        nativeTokenAddress: "bfc",
        scanLink: "https://explorer.mainnet.bifrostnetwork.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/bfc_token/logo_url/bfc/f0c01b58f084660f8c8ff43f5c85301c.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.TBFC]: {
        id: 49088,
        serverId: "tbfc",
        name: "Bifrost Testnet",
        enum: CHAINS_ENUM.TBFC,
        hex: "0xbfc0",
        network: "49088",
        nativeTokenSymbol: "TestnetBFC",
        nativeTokenAddress: "tbfc",
        scanLink: "https://explorer.testnet.bifrostnetwork.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tbfc_token/logo_url/tbfc/f0c01b58f084660f8c8ff43f5c85301c.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.ABERA]: {
        id: 80085,
        serverId: "abera",
        name: "Berachain Artio Testnet",
        enum: CHAINS_ENUM.ABERA,
        hex: "0x138d5",
        network: "80085",
        nativeTokenSymbol: "ArtioBERA",
        nativeTokenAddress: "abera",
        scanLink: "https://artio.beratrail.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/abera_token/logo_url/abera/ce82c4810fd0cec44ecbd2e9dcd864e0.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.ALOT]: {
        id: 432204,
        serverId: "alot",
        name: "Dexalot",
        enum: CHAINS_ENUM.ALOT,
        hex: "0x6984c",
        network: "432204",
        nativeTokenSymbol: "ALOT",
        nativeTokenAddress: "alot",
        scanLink: "https://subnets.avax.network/dexalot/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/alot_token/logo_url/alot/a03e5e8bc56a8bcd5f5c7b830e8b5877.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.XAI]: {
        id: 660279,
        serverId: "xai",
        name: "Xai",
        enum: CHAINS_ENUM.XAI,
        hex: "0xa1337",
        network: "660279",
        nativeTokenSymbol: "XAI",
        nativeTokenAddress: "xai",
        scanLink: "https://explorer.xai-chain.net/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/xai_token/logo_url/xai/022ab00135c182f6e67e583ecda93863.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.TSAVM]: {
        id: 3110,
        serverId: "tsavm",
        name: "SatoshiVM Testnet",
        enum: CHAINS_ENUM.TSAVM,
        hex: "0xc26",
        network: "3110",
        nativeTokenSymbol: "TestnetBTC",
        nativeTokenAddress: "tsavm",
        scanLink: "https://testnet.svmscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/tsavm_token/logo_url/tsavm/bf2e6d2050524a6d8f9bf621222e4d8e.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.GXAI]: {
        id: 47279324479,
        serverId: "gxai",
        name: "Xai Goerli Testnet",
        enum: CHAINS_ENUM.GXAI,
        hex: "0xb02113d3f",
        network: "47279324479",
        nativeTokenSymbol: "GoerliETH",
        nativeTokenAddress: "gxai",
        scanLink: "https://testnet-explorer.xai-chain.net/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/gxai_token/logo_url/gxai/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.SXAI]: {
        id: 37714555429,
        serverId: "sxai",
        name: "Xai Sepolia Testnet",
        enum: CHAINS_ENUM.SXAI,
        hex: "0x8c7f67225",
        network: "37714555429",
        nativeTokenSymbol: "SepoliaXAI",
        nativeTokenAddress: "sxai",
        scanLink: "https://testnet-explorer-v2.xai-chain.net/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/sxai_token/logo_url/sxai/022ab00135c182f6e67e583ecda93863.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.SBLAST]: {
        id: 168587773,
        serverId: "sblast",
        name: "Blast Sepolia Testnet",
        enum: CHAINS_ENUM.SBLAST,
        hex: "0xa0c71fd",
        network: "168587773",
        nativeTokenSymbol: "SepoliaETH",
        nativeTokenAddress: "sblast",
        scanLink: "https://testnet.blastscan.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/sblast_token/logo_url/sblast/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.ZETA]: {
        id: 7000,
        serverId: "zeta",
        name: "ZetaChain",
        enum: CHAINS_ENUM.ZETA,
        hex: "0x1b58",
        network: "7000",
        nativeTokenSymbol: "ZETA",
        nativeTokenAddress: "zeta",
        scanLink: "https://zetachain.blockscout.com/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/chain/logo_url/zeta/d0e1b5e519d99c452a30e83a1263d1d0.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.RARI]: {
        id: 1380012617,
        serverId: "rari",
        name: "RARI",
        enum: CHAINS_ENUM.RARI,
        hex: "0x52415249",
        network: "1380012617",
        nativeTokenSymbol: "ETH",
        nativeTokenAddress: "rari",
        scanLink: "https://mainnet.explorer.rarichain.org/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/rari_token/logo_url/rari/d61441782d4a08a7479d54aea211679e.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.HUBBLE]: {
        id: 1992,
        serverId: "hubble",
        name: "Hubble",
        enum: CHAINS_ENUM.HUBBLE,
        hex: "0x7c8",
        network: "1992",
        nativeTokenSymbol: "USDC",
        nativeTokenAddress: "hubble",
        scanLink: "https://explorer.hubble.exchange/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/hubble_token/logo_url/hubble/35ab0987153a8355a454223aae371ac7.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.TRARI]: {
        id: 1918988905,
        serverId: "trari",
        name: "RARI Testnet",
        enum: CHAINS_ENUM.TRARI,
        hex: "0x72617269",
        network: "1918988905",
        nativeTokenSymbol: "TestnetETH",
        nativeTokenAddress: "trari",
        scanLink: "https://explorer.rarichain.org/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/trari_token/logo_url/trari/389dd9a835250219889e01d5a31a75f1.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: true,
    },
    [CHAINS_ENUM.MODE]: {
        id: 34443,
        serverId: "mode",
        name: "Mode",
        enum: CHAINS_ENUM.MODE,
        hex: "0x868b",
        network: "34443",
        nativeTokenSymbol: "ETH",
        nativeTokenAddress: "mode",
        scanLink: "https://explorer.mode.network/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/mode_token/logo_url/mode/d61441782d4a08a7479d54aea211679e.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.MERLIN]: {
        id: 4200,
        serverId: "merlin",
        name: "Merlin",
        enum: CHAINS_ENUM.MERLIN,
        hex: "0x1068",
        network: "4200",
        nativeTokenSymbol: "BTC",
        nativeTokenAddress: "merlin",
        scanLink: "https://scan.merlinchain.io/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/merlin_token/logo_url/merlin/fe230e468272b84aba78d08bb4140456.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": false,
        },
        isTestnet: false,
    },
    [CHAINS_ENUM.DYM]: {
        id: 1100,
        serverId: "dym",
        name: "Dymension",
        enum: CHAINS_ENUM.DYM,
        hex: "0x44c",
        network: "1100",
        nativeTokenSymbol: "DYM",
        nativeTokenAddress: "dym",
        scanLink: "https://dym.fyi/tx/_s_",
        nativeTokenLogo: "https://static.debank.com/image/dym_token/logo_url/dym/ab62b0f446408c84a2e17d9178a4e8e9.png",
        nativeTokenDecimals: 18,
        eip: {
            "1559": true,
        },
        isTestnet: false,
    },
};
export const CHAINS_RAW_LIST = Object.values(CHAINS_RAW);
